import React from "react";
import { Link } from "react-router-dom";
import Icon from "../../../../components/base/Icon";
import { TodayScheduleItem } from "../../models/AdminDashboardModel";

type Props = {
    items?: TodayScheduleItem[]
}

function TodayScheduleWidget(props: Props) {
    const items = props.items ?? [];
    return (
        <div className="card border-0 shadow-sm h-100">
            <div className="card-header border-0 pt-5 d-flex align-items-center">
                <div className="flex-grow-1">
                    <h3 className="widget-title">Today's Schedule</h3>
                    <div className="widget-subtitle">{items.length} appointment{items.length === 1 ? "" : "s"}</div>
                </div>
                <Link to="/crm/jobs/calendar" className="btn btn-sm btn-light-primary">
                    <Icon icon="calendar" type="solid" size={12} className="me-1" />
                    Calendar
                </Link>
            </div>
            <div className="card-body pt-3" style={{ maxHeight: 420, overflowY: "auto" }}>
                {items.length === 0 && (
                    <div className="text-center text-gray-500 py-8">
                        <Icon icon="calendar" type="thin" size={48} className="text-gray-400 mb-3" />
                        <div>No appointments scheduled for today</div>
                    </div>
                )}
                {items.map(it => (
                    <Link key={it.id} to={`/crm/jobs/details/${it.id}`} className="schedule-row d-flex align-items-center text-decoration-none">
                        <div className="me-3 text-center" style={{ minWidth: 56 }}>
                            <div className="schedule-time">{it.appointmentTime || "—"}</div>
                        </div>
                        <div className="flex-grow-1 min-w-0 pe-2">
                            <div className="schedule-name text-truncate">{it.fullName || "Unknown"}</div>
                            <div className="schedule-meta text-truncate">
                                {it.jobType ? <>{it.jobType}{it.techName ? " · " : ""}</> : null}
                                {it.techName ? <span>{it.techName}</span> : null}
                            </div>
                        </div>
                        {it.statusName && (
                            <span className="badge" style={{
                                background: (it.statusColor || "#A1A5B7") + "22",
                                color: it.statusColor || "#A1A5B7",
                                fontWeight: 600,
                                fontSize: "0.7rem"
                            }}>
                                {it.statusName}
                            </span>
                        )}
                    </Link>
                ))}
            </div>
        </div>
    );
}

export default TodayScheduleWidget;
